export default () => ({
  component: 'logs-action-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
